/**
 * Currency switcher + cart badge — relocated from inline <script> in both
 * layout_default and layout_public. Server data (current currency, whether the
 * currency is locked to the client's billing currency) is read from the
 * #mero-currency-data island the layouts render, so no server templating lives
 * in this file. Exposes window.fbpanel.switchCurrency / syncCartBadge, as before.
 */
(function () {
    var data = document.getElementById('mero-currency-data');
    var currencyLocked = !!(data && data.getAttribute('data-currency-locked') === '1');
    var currentCurrencyCode = (data && data.getAttribute('data-currency-code')) || '';
    var currencySwitching = false;

    function switchCurrency(code) {
        if (!code || currencyLocked || currencySwitching) return;
        var next = String(code).toUpperCase();
        if (next === String(currentCurrencyCode).toUpperCase()) return;

        currencySwitching = true;
        API.guest.post('cart/set_currency', { currency: next }, function () {
            window.location.reload();
        }, function () {
            currencySwitching = false;
        }, false);
    }

    function bindCurrencyControls() {
        document.querySelectorAll('[data-set-currency]').forEach(function (btn) {
            if (btn.dataset.currencyBound === '1') return;
            btn.dataset.currencyBound = '1';
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                switchCurrency(btn.dataset.setCurrency || '');
            });
        });
        document.querySelectorAll('select.currency_selector').forEach(function (select) {
            if (select.dataset.currencyBound === '1') return;
            select.dataset.currencyBound = '1';
            select.addEventListener('change', function () {
                switchCurrency(select.value || '');
            });
        });
    }

    function syncCartBadge() {
        API.guest.get('cart/get', {}, function (cart) {
            var count = (cart && Array.isArray(cart.items)) ? cart.items.length : 0;
            var el = document.getElementById('cart-badge-topbar');
            if (!el) return;
            if (count > 0) {
                el.textContent = count > 99 ? '99+' : count;
                el.style.display = 'flex';
            } else {
                el.textContent = '';
                el.style.display = 'none';
            }
        }, null, false);
    }

    function init() {
        bindCurrencyControls();
        syncCartBadge();
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
    document.addEventListener('stablepanel:cartUpdated', syncCartBadge);
    window.fbpanel = window.fbpanel || {};
    window.fbpanel.syncCartBadge = syncCartBadge;
    window.fbpanel.switchCurrency = switchCurrency;
}());
